export const cookies_string = 'HKULEARNING';
export const server_ip=''//'http://43.198.18.229'

//prod: 'http://43.198.18.229
